import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-dialog-export',
    templateUrl: './dialog-export.component.html',
    styleUrl: './dialog-export.component.scss',
    providers: [DatePipe],
    standalone: false
})
export class DialogExportComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() currentDate: Date = new Date();
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() exportSubmit = new EventEmitter<FormGroup>();

  defaultExportName = '';
  exportFormGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private datePipe: DatePipe
  ) {
    this.exportFormGroup = this.fb.group({
      exportName: ['', [Validators.maxLength(128)]],
      dateRange: [null, Validators.required],
      format: ['CSV', Validators.required]
    });

    this.exportFormGroup.get('dateRange')?.valueChanges.subscribe((dateRange: Date[]) => {
      this.updateDefaultExportName();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue === true) {
      this.updateDefaultExportName();
    }
  }

  private updateDefaultExportName(): void {
    const exportType = this.getExportTypeFromUrl();
    const todayDate = this.formatDate(new Date());

    const defaultExportName = `${exportType}_${todayDate}`;
    const exportNameControl = this.exportFormGroup.get('exportName');

    if (!exportNameControl) {
      return;
    }

    const currentName = exportNameControl.value;

    if (!currentName || currentName === this.defaultExportName) {
      exportNameControl.setValue(defaultExportName);
      this.defaultExportName = defaultExportName;
    }
  }

  private getExportTypeFromUrl(): string {
    // get the last part of the URL without params
    const exportType = this.router.url.split('?')[0].split('/')[1] || 'export';

    return exportType.charAt(0).toUpperCase() + exportType.slice(1);
  }

  private formatDate(date: Date): string {
    return this.datePipe.transform(date, 'ddMMyyyyHHmm') ?? '';
  }

  onCancel() {
    this.visibleChange.emit(false);
  }

  onExport() {
    if (this.exportFormGroup.valid) {
      this.exportSubmit.emit(this.exportFormGroup);
      this.visibleChange.emit(false);
    }
  }

  reset() {
    this.exportFormGroup.reset({
      exportName: this.getExportTypeFromUrl(),
      dateRange: null,
      format: 'CSV'
    });
  }
}
